var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pure-g",attrs:{"id":"main-wrap"}},[_c('div',{staticClass:"pure-u-3-5",attrs:{"id":"main-col"}},[_c('h3',[_vm._v(_vm._s(_vm.publication))]),_vm._v(" "),_c('div',{attrs:{"id":"home-grapes"}},_vm._l((_vm.grapes),function(grape){return _c('Grape',{key:grape.id,attrs:{"grapeInstance":grape}})}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35573985","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Publication.vue
// module id = null
// module chunks = 